import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormModule } from './FormModule/form.module';
import { SharedModule } from './shared/shared.module';
import { PaginationComponent } from './shared/Components/pagination/pagination.component';
import { NgxPaginationModule } from 'ngx-pagination';




@NgModule({
  declarations: [],
  imports: [
    NgxPaginationModule,
    CommonModule,
    TranslateModule,
    FormModule,
    SharedModule
  ],
  exports:[]
})
export class CoreModule { }